<template>
	<div class="fwd-cku-test">
		<sf-data-table
			ref="dataTable"
			stripe
			index
			:columns="columns"
			:rows="rows"
			fit="fit"
			:selectionColumn="{ width: '50px' }"
			:excel="isButton_(scrId, 'EX')"
			height="45vh"
		>
			<template v-slot:customRows="slotProps">
				<template v-if="slotProps.column.property === 'fwdImgNm'">
					<template v-if="slotProps.row.lgrpCd && slotProps.row.lgrpCd === 'PHTG'">
						<file-upload-grid
							:id="slotProps.row.tymaCd + slotProps.row.sgrpCd + slotProps.row.lgrpCd"
							width="100%"
							height="100%"
							:slotPropsRow="slotProps.row"
							:propFileObject="slotProps.row.fwdImgFileDb"
							accept="image/jpeg,image/gif,image/png"
							@singleFile="fileUpload"
							@deletePropFile="deletePropFile"
							@onDownload="onDownloadFile"
							:fileNameMax="7"
							:customFileName="slotProps.row.rgnId === 'NEW_DATA' && !!slotProps.row.fwdImgFileId ? slotProps.row.sgrpNm : ''"
						></file-upload-grid>
					</template>
					<template v-else>
						<span>
							{{ getMessage_('QWCC001328') }}
						</span>
					</template>
				</template>
				<template v-if="slotProps.column.property === 'mark'">
					<template v-if="!selectedRow.csetDd && attentionList.includes(slotProps.row.ckuLgrpCd)">
						<i class="icon-sf-error warned"></i>
					</template>
				</template>
			</template>
		</sf-data-table>
	</div>
</template>

<script>
import _ from 'lodash';
import FileUploadGrid from '@qms/Components/FileUploadGrid.vue';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/fcku/FwdCkuStts/store/helpers';
export default {
	props: { scrId: { type: String, default: '' } },
	data() {
		return { photoEditable: true };
	},
	components: { FileUploadGrid },
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.resultList;
		},
		columns() {
			return this.getPopupColumns_;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async fileUpload(value, row) {
			//파일 이름이 같을 경우 업로드 제한이 있다.
			const isDup = _.find(this.resultList, result => {
				return result.fwdImgNm === value.name || result.fwdImgFile?.name === value.name;
			});
			if (!isDup) {
				row.fwdImgFile = value;
				// 작성이 완료된 이미지 수정의 경우
				if (this.selectedRow.csetDd) {
					try {
						const formData = new FormData();
						const { pmcNo, ipnNos } = this.selectedRow;
						const { lgrpCd, sgrpCd, fwdImgFile, fwdImgFileId } = row;
						formData.set('pmcNo', pmcNo);
						formData.set('ipnNos', ipnNos);
						formData.set('lgrpCd', lgrpCd);
						formData.set('sgrpCd', sgrpCd);
						formData.set('fwdImgFile', fwdImgFile);
						const { data } = await this.updateImg_(formData);
						if (data?.header?.code == 0) {
							const { custCd, custNm } = this.selectedRow;
							this.setPopupSearchParam_({ key: 'custCd', value: custCd });
							this.$sf_toggleLoading(true);
							await this.getPopupList_(this.hasChanged_);
							this.setSelectedRow_({ key: 'custCd', value: custCd });
							this.setSelectedRow_({ key: 'custNm', value: custNm }); // 업체 변경시 서버에서 고객사명을 못가져옴 (아직 저장된 데이터가 아니기 때문)
							this.$sf_toggleLoading(false);
						}
					} catch (error) {
						console.log(error);
					}
				}
			} else {
				row.fwdImgFileId = null;
				row.fwdImgNm = '';
				row.fwdImgFile = {};
				row.fwdImgFileDb = {};
				this.$sf_toast({ type: 'error', title: 'Warning', message: this.getMessage_('QWCC001869') }); //파일 이름이 같을 경우 업로드가 제한됩니다.
			}
		},
		deletePropFile(row) {
			if (this.selectedRow.csetDd) {
				//작성 완료된 이미지 삭제 시
				const formData = new FormData();
				const { pmcNo, ipnNos } = this.selectedRow;
				const { lgrpCd, sgrpCd, fwdImgFileId } = row;
				formData.set('pmcNo', pmcNo);
				formData.set('ipnNos', ipnNos);
				formData.set('lgrpCd', lgrpCd);
				formData.set('sgrpCd', sgrpCd);
				formData.set('fwdImgFileId', fwdImgFileId);
				this.updateImg_(formData);
			}
			row.fwdImgFileId = null;
			row.fwdImgNm = '';
			row.fwdImgFile = {};
			row.fwdImgFileDb = {};
		},
		async onDownloadFile(file) {
			const { fileId } = file;
			await this.fileDownload_({ fileId, fileSeq: '1' });
		}
	}
};
</script>
